enum EContentType {
    APPLICATION_X_WWW_FORM_URLENCODED = 'application/x-www-form-urlencoded',
}

export default EContentType
